import React from 'react';

import PropTypes from 'prop-types';

import { useFeatures } from '@atc/features';

import { MyWalletGridContainer as ConnectedMyWalletGrid } from 'reaxl-wallet';

import { paymentsDuck } from '@/ducks';

function MyWalletGridContainer({ uiContext, showIcon }) {
    const {
        srp_wallet_grid_promo_card: [enableWalletPromoCard],
    } = useFeatures(['srp_wallet_grid_promo_card']);

    return (
        !enableWalletPromoCard
        && (
            <div className="col-xs-12">
                <ConnectedMyWalletGrid
                    paymentsDuck={paymentsDuck}
                    showIcon={showIcon}
                    uiContext={uiContext || 'basic'}
                />
            </div>
        )

    );
}

MyWalletGridContainer.propTypes = {
    /**
     * Bool to show/hide icon
     */
    showIcon: PropTypes.bool,
    /**
     * uiContext for themes
     */
    uiContext: PropTypes.oneOf(['default', 'basic', 'light', 'welcome']),
};

export default MyWalletGridContainer;
